/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdfExportCheck
 */
export interface PdfExportCheck {
    /**
     * 
     * @type {boolean}
     * @memberof PdfExportCheck
     */
    exportFinished: boolean;
}

export function PdfExportCheckFromJSON(json: any): PdfExportCheck {
    return PdfExportCheckFromJSONTyped(json, false);
}

export function PdfExportCheckFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfExportCheck {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exportFinished': json['export_finished'],
    };
}

export function PdfExportCheckToJSON(value?: PdfExportCheck | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'export_finished': value.exportFinished,
    };
}


